import { CustomerTenantLogoClient } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import {
  TenantLogoArgs,
  TenantLogoResponse,
} from "shared-ui/src/shared-features/my-acccounts/types/TenantLogo";
import ms from "ms";

const CustomerTenantLogoQKey = "customer-tenant-logo";

function isNotFoundError(error: unknown): boolean {
  if (typeof error !== "object" || error === null || !("response" in error)) {
    return false;
  }

  const response = error.response as { status?: number } | undefined;
  return response?.status === 404;
}

export function useGetTenantCurrentLogo({
  id,
}: TenantLogoArgs): UseQueryResult<TenantLogoResponse | null, Error> {
  const api = useApi(CustomerTenantLogoClient);

  const fetch = async (): Promise<TenantLogoResponse | null> => {
    try {
      const res = await api.downloadCustomerTenantLogo();

      return {
        body: await res.data.arrayBuffer(),
        contentType: res.headers?.["content-type"] ?? null,
      };
    } catch (error: unknown) {
      if (isNotFoundError(error)) {
        return null;
      }

      throw error;
    }
  };

  return useQuery({
    queryKey: [CustomerTenantLogoQKey, id],
    enabled: !!id,
    queryFn: fetch,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: ms("60m"),
  });
}
